export default "__VITE_ASSET__DB2dGmt4__"